var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Group } from '@/models/Group';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Vue } from 'vue-property-decorator';
import { TabsColorEnum } from '@/config/theme';
import NavigationCard from '@/components/NavigationCard.vue';
import { RolesEnum } from '@/items/Roles';
let Projects = class Projects extends Vue {
    constructor() {
        super(...arguments);
        // #region @VModel
        // #endregion
        // #region @PropSyncs
        // #endregion
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.groupId = this.$route.params.id || '';
        this.group = null;
        // protected get
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        if (!this.groupId)
            return;
        await this.fetchGroupProjects();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    getStudentCount(users) {
        if (!users || users.length === 0) {
            return '0';
        }
        return users.length.toString();
    }
    // #endregion
    // #region Async methods (api calls only)
    async fetchGroupProjects() {
        try {
            this.group = await new Group().include('user_projects').find(this.groupId);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Getters & Setters
    get user() {
        return this.$store.state.Auth;
    }
    get groupProjects() {
        if (!this.group || !this.group.user_projects) {
            return [];
        }
        return Object.entries(this.group.user_projects).map(([id, { project, users }]) => ({
            id,
            project,
            users,
        }));
    }
    getTabRoute(tabIndex, project, users) {
        if (!project || !project.id || !this.groupId || !users || users.length === 0) {
            return '';
        }
        const baseRoute = `/projects/${project.id}`;
        const userIds = users.map((u) => u.id).join(',');
        switch (tabIndex) {
            case 0:
                return `${baseRoute}/subjects`;
            case 1:
                return `${baseRoute}/notes`;
            case 2:
                return `${baseRoute}/project-plan`;
            case 3:
                return `${baseRoute}/media`;
            case 4:
                return `${baseRoute}/documents`;
            case 5:
                return `/groups/${this.groupId}/student-overview?projectId=${project.id}&userIds=${userIds}`;
            case 6:
                return `/groups/${this.groupId}/curriculum?projectId=${project.id}&userIds=${userIds}`;
            default:
                return baseRoute;
        }
    }
    get tabs() {
        return [
            {
                color: TabsColorEnum.LIGHT_BLUE,
                description: `${this.$tc('navigationCard.project.subjects')}`,
                icon: 'flag',
                is_visible: true,
                label: this.$tc('projects.tabs.subjects'),
            },
            {
                color: TabsColorEnum.LIGHT_GREEN,
                description: this.$tc('Add or read the evaluation of the goal set'),
                icon: 'speaker_notes',
                is_visible: true,
                label: this.$tc('Evaluation'),
            },
            {
                color: TabsColorEnum.ORANGE,
                description: `${this.$tc('Add or read the goal set plan')}`,
                icon: 'folder',
                is_visible: true,
                label: this.$tc('projects.tabs.project_plan'),
            },
            {
                color: TabsColorEnum.RED,
                description: `${this.$tc('Add or view files related to the goal set')}`,
                icon: 'perm_media',
                is_visible: true,
                label: this.$tc('Files'),
            },
            {
                color: TabsColorEnum.BLUE,
                description: `${this.$tc('navigationCard.project.media')}`,
                icon: 'receipt_long',
                is_visible: true,
                label: this.$tc('Documents'),
            },
            // NEW TABS FOR GROUP PROJECTS
            {
                color: TabsColorEnum.DARK_GREEN,
                description: `${this.$tc('navigationCard.group.studentOverview')}`,
                icon: 'area_chart',
                is_visible: this.user.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.TRAINER, RolesEnum.TEACHER]),
                label: this.$tc('navigationCard.group.titles.studentOverview'),
            },
            {
                color: TabsColorEnum.ORANGE,
                description: `${this.$tc('navigationCard.group.curriculum')}`,
                icon: 'dynamic_feed',
                is_visible: this.user.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.BOARD, RolesEnum.TEACHER, RolesEnum.TRAINER]),
                label: this.$tc('navigationCard.group.titles.curriculum'),
            },
        ];
    }
};
Projects = __decorate([
    Component({
        components: {
            NavigationCard,
        },
    })
], Projects);
export default Projects;
// #endregion
// #region Constants
// #endregion
